import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { DialogTitle } from '@radix-ui/react-dialog'

import { HELP_EMAIL } from '@/shared/config/HELP_EMAIL'
import { Button, ButtonProps } from '@/shared/ui/Button'
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader
} from '@/shared/ui/Dialog'

interface ErrorModalProps {
	title: ReactNode
	description: ReactNode
	TopLeftButton: ReactElement<ButtonProps, typeof Button>
	TopRightButton: ReactElement<ButtonProps, typeof Button>
	BottomButton: ReactElement<ButtonProps, typeof Button>
}

export const ErrorModal = ({
	title,
	description,
	TopLeftButton,
	TopRightButton,
	BottomButton
}: ErrorModalProps) => {
	const { t } = useTranslation('errors')

	return (
		<Dialog open={true}>
			<DialogContent>
				<div className="mx-auto max-w-[60rem] flex-col items-center justify-center">
					<DialogHeader>
						<DialogTitle className="ts-headline-2">{title}</DialogTitle>
					</DialogHeader>

					<div className="ts-4 mt-12">{description}</div>

					<div className="ts-4 mt-4">
						{t('contactBeforeEmail')}

						<Button
							className="inline px-2 py-0"
							variant="link"
							asChild
						>
							<a href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</a>
						</Button>
						{t('contactAfterEmail')}
					</div>

					<DialogFooter className="mx-auto mt-10 flex w-full max-w-[50rem] flex-col gap-y-2">
						<div className="flex gap-x-2">
							<TopLeftButton.type
								className="w-full"
								variant="outline"
								{...TopLeftButton.props}
							/>
							<TopRightButton.type
								className="w-full"
								variant="outline"
								{...TopRightButton.props}
							/>
						</div>

						<div>
							<BottomButton.type
								className="w-full"
								variant="default"
								{...BottomButton.props}
							/>
						</div>
					</DialogFooter>
				</div>
			</DialogContent>
		</Dialog>
	)
}
